export default __webpack_public_path__ + "static/small-3-572756364ace824471487955af928904.png";